import React from 'react';
import styled from "styled-components";
import SwiperCore, {Navigation, Pagination, Autoplay} from 'swiper';
import {Swiper, SwiperSlide} from "swiper/react";
import {randomString} from "../../helpers/helpers";

SwiperCore.use([Navigation, Pagination, Autoplay]);

export const CarouselItem = SwiperSlide;

function Carousel({className, containerClassName, breakpoints, navigation_show = true, pagination = false, autoplay, delay, children}) {
    const randomKey = randomString();

    const navigation = {
        nextEl: '.multiple-swiper-next' + randomKey,
        prevEl: '.multiple-swiper-prev' + randomKey,
    };

    const pagination_conf = {
        el: '.carousel-pagination' + randomKey,
        type: 'bullets',
        dynamicBullets: true
    };

    const autoplay_conf = {
        delay: 5000,
        disableOnInteraction: false
    };

    if (typeof delay !== "undefined") {
        autoplay_conf.delay = delay;
    }

    const params = {
        slidesPerView: 'auto',
        spaceBetween: 16,
        navigation: navigation,
        breakpoints: breakpoints
    };

    if (autoplay) {
        params['autoplay'] = autoplay_conf;
    }

    if (pagination) {
        params['pagination'] = pagination_conf;
    }

    return (
        <Container className={(containerClassName ? containerClassName : '')}>
            <Card className={"position-relative " + (className ? className : '')}>
                <div className={"swiper-pagination carousel-pagination" + randomKey}/>
                {
                    (navigation_show) ?
                        <React.Fragment>
                            <div className={"swiper-button-next multiple-swiper-next" + randomKey}/>
                            <div className={"swiper-button-prev multiple-swiper-prev" + randomKey}/>
                        </React.Fragment>
                        : ''
                }


                <Swiper {...params}>
                    {children}
                </Swiper>
            </Card>
        </Container>
    )
}

export default React.memo(Carousel);

// styles

const Card = styled.div`
    
    @media (max-width: ${props => props.theme.screenSmMax}) {
        padding: 0 24px;
        overflow: visible;
        position: static;
        
        .swiper-container {
            overflow: visible;   
        }
    }
    
    .carousel-pagination {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translate(-50%, 0);
        min-width: 80px;
        
        .swiper-pagination-bullet {
            margin-right: 8px;
            
            &:first-child {
                margin-right: 0;
            }
            
            &.swiper-pagination-bullet-active {
                background-color: ${props => props.theme.primary};
            }
        }
    }
`;

const Container = styled.div`

    .swiper-button-next {
        left: -22px;
    }
    
    .swiper-button-prev {
        right: -22px;
    }
    
    .swiper-container {
        padding-bottom: 24px;
        //margin-bottom: -24px;
    }
    
  @media (max-width: ${props => props.theme.screenSmMax}) {
      overflow: hidden;
  }
`;
